import BigNumber from 'bignumber.js'

export const ZERO = new BigNumber(0)
export const ONE = new BigNumber(1)
export const PERCENT = new BigNumber(100)
